<template>
  <div v-loading="loading" class="mobile-card-list">
    <div v-if="!data.length" class="mobile-card-empty">{{ emptyText }}</div>
    <div
      v-for="(row, index) in data"
      :key="rowKey ? row[rowKey] : index"
      class="mobile-card"
    >
      <div
        v-for="field in fields"
        :key="field.prop || field.label"
        class="mobile-card-row"
        :class="{ 'is-block': field.block }"
      >
        <span class="mobile-card-label">{{ field.label }}</span>
        <span class="mobile-card-value">
          <slot :name="field.prop" :row="row">
            {{ formatValue(row, field) }}
          </slot>
        </span>
      </div>
      <div v-if="$scopedSlots.actions" class="mobile-card-actions">
        <slot name="actions" :row="row" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileCardList',
  props: {
    data: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    rowKey: { type: String, default: 'id' },
    emptyText: { type: String, default: '暂无数据' },
  },
  methods: {
    formatValue(row, field) {
      if (field.format) return field.format(row);
      const val = row[field.prop];
      return val === null || val === undefined || val === '' ? '-' : val;
    },
  },
};
</script>
